module.exports = __webpack_public_path__ + "static/media/retreat.34b1fc77.jpg";